<div class="desktop-content scrollable">
  <div class="desktop-column">
    @if (hasAdministration$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fa fa-wrench"></i>
          <span>Référentiel</span>
        </div>
        <yo-desktop-drop-menu [items]="referentielItems"></yo-desktop-drop-menu>
      </div>
    }

    @if (hasGestionFournisseurs$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fa fa-truck"></i>
          <span>Fournisseurs</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-fournisseurs"
          [label]="'Voir la liste des fournisseurs'">
        </yo-desktop-button>

        @if (gestionProduitsIapro) {
          <yo-desktop-button
            routerLink="/gestion-groupe-achat"
            [label]="'Voir la liste des groupes achats'">
          </yo-desktop-button>
        }

        <yo-desktop-button
          routerLink="/gestion-fournisseurs/articles/article-affecte"
          [label]="'Mise à jour des articles'">
        </yo-desktop-button>

        @if (hasMarche$ | async) {
          <yo-desktop-button
            routerLink="/gestion-marche"
            [label]="'Marchés'">
          </yo-desktop-button>
        }
      </div>
    }

    @if (hasUniteDeProduction$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fa fa-industry"></i>
          <span>Unités de production</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-unitesproduction"
          [label]="'Voir les unités de production'"
          [tooltip]="'Unités de production'">
        </yo-desktop-button>
      </div>
    }
  </div>

  <div class="desktop-column">
    @if (gestionProduitsIapro) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-carrot"></i>
          <span>Produits</span>
        </div>
        <yo-desktop-button
          routerLink="/gestionproduits"
          [label]="'Voir les produits'">
        </yo-desktop-button>
      </div>
    }

    @if (hasGestionMenus$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-utensils"></i>
          <span>Menus</span>
        </div>
        @if (hasGestionGemrcn$ | async) {
          <yo-desktop-button
            routerLink="/gestiongemrcn"
            [label]="'Modèles de menus'">
          </yo-desktop-button>
        }
        <yo-desktop-button
          routerLink="/gestioncontrats"
          [label]="'Offres alimentaires'">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestionmenus"
          [label]="'Planning des menus'">
        </yo-desktop-button>
      </div>
    }

    @if (hasGestionClients$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-users"></i>
          <span>Commandes clients</span>
        </div>
        @if (hasGestionPlc$ | async) {
          <yo-desktop-button
            routerLink="/gestion-plc/menu-plc"
            [label]="'Planning des effectifs'">
          </yo-desktop-button>
        }
        @if (hasGestionPlc$ | async) {
          <yo-desktop-button
            routerLink="/gestion-clients"
            [label]="'Clients et points de livraison'">
          </yo-desktop-button>
        }
        @if (hasPortailUtilisateur$ | async) {
          <yo-desktop-button
            routerLink="/gestion-plc/portail-plc"
            [label]="'Portail de saisie des effectifs'">
          </yo-desktop-button>
        }
        @if (hasGestionPlc$ | async) {
          <yo-desktop-button
            routerLink="/gestion-clients/fermeture"
            [label]="'Fermeture Clients'">
          </yo-desktop-button>
        }
      </div>
    }

    @if (hasGestionBesoins$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-shopping-basket"></i>
          <span>Besoins</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-listes-besoins/lb/listes-de-besoins"
          [label]="'Voir les besoins'">
        </yo-desktop-button>
      </div>
    }

    @if ((hasGestionCommandes$ | async) || (hasCommandesTableauBord$ | async) || ((hasCommandesReception$ | async) && (hasStocks$ | async))) {
      <div>
        <div class="desktop-header">
          <i class="fa fa-shopping-cart"></i>
          <span>Commandes fournisseurs</span>
        </div>
        @if (hasCommandesTableauBord$ | async) {
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/tableau-de-bord"
            label="Tableau de bord">
          </yo-desktop-button>
        }
        @if (hasGestionCommandes$ | async) {
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/propositions"
            label="Propositions de commande">
          </yo-desktop-button>
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/refusees"
            label="Commandes refusées">
          </yo-desktop-button>
          <yo-desktop-button class="desktop-button"
            routerLink="/gestion-commandes-fournisseurs/bc/a-valider"
            label="Commandes à valider">
          </yo-desktop-button>
        }
        @if ((hasCommandesReception$ | async) && (hasStocks$ | async)) {
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/a-receptionner"
            label="Commandes à réceptionner">
          </yo-desktop-button>
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/receptions"
            label="Commandes réceptionnées">
          </yo-desktop-button>
        }
        @if ((hasGestionCommandes$ | async) && (hasFacturation$ | async)) {
          <yo-desktop-button
            routerLink="/gestion-commandes-fournisseurs/bc/facturees"
            label="Commandes facturées">
          </yo-desktop-button>
        }
      </div>
    }
  </div>

  <div class="desktop-column">
    @if (hasStocks$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-cubes"></i>
          <span>Stocks</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-stocks/stocks/matieres-premieres"
          label="Matières premières">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-stocks/mouvements/grille-mouvements"
          label="Mouvements">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-stocks/stocks/inventaire"
          label="Inventaire">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-stocks/historique-inventaire"
          label="Historique inventaire">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-stocks/validation-inventaire"
          label="Validation fin de mois">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-stocks/stocks/stock-minimum"
          label="Stock minimum">
        </yo-desktop-button>
      </div>
    }

    @if (hasGestionProduction$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-newspaper"></i>
          <span>Production</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-production/pp/plans-de-production"
          label="Plans de production">
        </yo-desktop-button>
      </div>
    }

    @if ((hasGestionIDistri$ | async) || (hasAdministration$ | async)) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-box-open"></i>
          <span>Conditionnements</span>
        </div>
        <yo-desktop-button
          routerLink="/gestion-conditionnements/modeles-plats"
          label="Modèles de plats">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-conditionnements/modeles-plc"
          label="Modèles points de livraison">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/gestion-conditionnements/regroupement-plat-plc"
          label="Regroupement plat / livraison">
        </yo-desktop-button>
        @if (hasAdministration$ | async) {
          <yo-desktop-button
            label="Purge complète"
            (click)="purgeConditionnement()">
          </yo-desktop-button>
        }
        @if ((hasGestionProduction$ | async) && (hasGestionIDistri$ | async)) {
          <yo-desktop-button
            routerLink="/gestion-production/organisations-tournees"
            label="Organisations de tournées">
          </yo-desktop-button>
        }
      </div>
    }

    @if (hasEgalim$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-utensils"></i>
          <span>EGAlim</span>
        </div>
        <yo-desktop-button
          routerLink="/egalim/point-teledeclaration"
          label="Point de télédeclaration Ma Cantine">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/egalim/statistiques"
          label="Statistiques EGAlim & Ma cantine">
        </yo-desktop-button>
      </div>
    }

    @if (hasGef$ | async) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-money-bill-transfer"></i>
          <span>GEF</span>
        </div>
        <yo-desktop-button
          routerLink="/adm/configuration-gef/connecteurs"
          label="Connecteurs">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/adm/configuration-gef/lanceurs-flux"
          label="Lanceurs de flux">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/adm/gef/historique-flux"
          label="Historique des flux">
        </yo-desktop-button>
        <yo-desktop-button
          routerLink="/adm/gef/monitoring"
          label="Monitoring">
        </yo-desktop-button>
      </div>
    }

    @if ((hasGestionFacturationClient$ | async) || (hasCmdFacturation$ | async) || (hasFactureExterne$ | async) || (hasAvoirExterne$ | async)) {
      <div>
        <div class="desktop-header">
          <i class="fas fa-boxes"></i>
          <span>Facturation</span>
        </div>
        <yo-desktop-drop-menu [items]="facturationItems"></yo-desktop-drop-menu>
      </div>
    }
  </div>
</div>

